<template>
  <div>
    <div>
    <div class="flex">
      <div class="w-full text-center">
        <p
          :class="[
            'text-xl font-bold text-gray-700 additionTitle border-b-1 my-6' /*, theme.AdditionsPopUp.HeadertextColor*/,
          ]"
          :style="kioskAdditionTitleLine + kioskAdditionTitleColor"
        >
          <span class="bg-white px-6 text-2xl"
          :style="menuSubCategoriesBackground ? menuSubCategoriesBackground : mainSubCategorysBackground">
            {{ modifierGroup[`name_${language}`] }}</span
          >
        </p>
        <p
          v-if="modifierGroup.minSelectedAmount"
          class="text-sm -mt-3 mb-2 requiredTitle"
        >
          Required
        </p>
      </div>
      <div class="ml-2 w-12 flex flex-col justify-center">
        <p v-if="modifierGroup.minSelectedAmount" class="text-xs whitespace-no-wrap">
          {{ lang["minimum_addition_selection"][language] }}:
          {{ modifierGroup.minSelectedAmount }}
        </p>
        <p v-if="modifierGroup.maxSelectedAmount > 0" class="text-xs whitespace-no-wrap">
          {{ lang["maximum_addition_selection"][language] }}:
          {{ modifierGroup.maxSelectedAmount }}
        </p>
      </div>
    </div>

      <div :class="[' rounded-xl mt-2 borderlastChild grid grid-cols-3 gap-8']">
        <div
          v-for="(addition, index) in modifierGroup.Additions"
          :key="addition.Id"
        >
          <!-- <comboAddition
            :modifierGroup="modifierGroup"
            :addition="addition"
            :index="index"
            :groupIndex="groupIndex"
          /> -->
          <label
            :class="[
              'borderlastChild w-full',
              addition.picture_url ? 'borderBottomNone' : 'borderNone',
            ]"
          >
            <div
              class="rounded-xl w-full overflow-hidden"
              :style="makeStyles(itemAdditionsRadius , kioskModifierItemBorder)"
            >
              <div
                :class="[
                  'flex justify-center text-center cursor-pointer AdditionItemWrapper AdditionItemWrapper--open',
                  menu.is_kiosk_full_picture ? '' : 'rounded-t-xl',
                ]"
                v-if="addition.picture_url"
              >
                <Picture
                  class="additionsPicture"
                  v-if="addition.picture_url"
                  :src="addition.picture_url"
                  alt
                  :class="['rounded-t-xl h-24 md:w-full object-cover']"
                  keepRatio
                />
              </div>
              <input
                @click="
                  giveComboDealId(index, groupIndex);
                  selectModifier(
                    modifierGroup.AdditionGroupId,
                    addition.price,
                    addition.Id,
                    { modifierGroup, addition }
                  );
                  modifierGroup.maxSelectedAmount == 1 &&
                    uncheck($event, addition.Id, addition.price);
                "
                class="mr-2 leading-tight input w-full hidden"
                :type="
                  modifierGroup.maxSelectedAmount == 1 ? 'radio' : 'checkbox'
                "
                :value="addition"
                :name="modifierGroup[`name_${language}`]"
              />
              <div
                class="pr-4 py-2 flex justify-between p-2 pl-6 activeColorRadius shadow h-16 items-center"
                :style="
                 isAlreadySelected(addition)
                    ? listsActiveBackground
                    : listsBackground
                "
              >
                <!-- {{ addition.Id }} -->
                <div :class="[' items-center flex']">
                  <div class="block">
                    <span
                      :class="[
                        'font-semibold',
                        { active: isActive } /*[theme.body.textColor]*/,
                      ]"
                      :style="
                 isAlreadySelected(addition)
                      ? listsActiveText
                          : listsText
                      "
                      >{{ addition[`name_${language}`] }}
                    </span>
                    <p
                      v-if="addition.price > 0"
                      class="text-sm font-semibold pr-1"
                      :style="
                 isAlreadySelected(addition)
                          ? listsActiveText
                          : listsText
                      "
                    >
                      {{ currency }} {{ addition.price }}
                    </p>
                  </div>
                </div>

                <div class="flex">
                  <div style="listsBackground">
                    <label v-if="addition.price > 0">
                      <input
                        @click="
                          selectModifier(
                            modifierGroup.AdditionGroupId,
                            addition.price,
                            addition.Id,
                            { modifierGroup, addition }
                          );
                          modifierGroup.maxSelectedAmount == 1 &&
                            uncheck($event, addition.Id, addition.price, {
                              modifierGroup,
                              addition,
                            });
                        "
                        class="mr-2 leading-tight input hidden"
                        :type="
                          modifierGroup.maxSelectedAmount == 1
                            ? 'radio'
                            : 'checkbox'
                        "
                        :value="addition"
                        :name="modifierGroup[`name_${language}`]"
                      />
                      <span
                        :class="[
                          'flex items-center justify-center rounded-xxl h-auto w-auto border-1  extra ',
                          disableBackground,
                          isAlreadySelected(addition) ? 'p-1.5' : 'p-1'
                        ]"
                        :style="
                 isAlreadySelected(addition)
                        ? listActivePrice + listActivePriceBorder
                            : '' + additionAddBackground
                        "
                      >
                        
                        <svg 
                        v-if="isAlreadySelected(addition)"
                        xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" 
                        :stroke="
                          isAlreadySelected(addition)
                          ? selectItemActiveColor
                          : selectItemColor
                        " 
                        stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        <svg
                          v-else
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="w-4 h-4"
                        >
                          <path
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            fill="none"
                            :stroke="
                              isAlreadySelected(addition)
                              ? selectItemActiveColor
                              : selectItemColor
                            "
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </label>
                    <span
                      v-if="!addition.price"
                      :class="[
                        'flex items-center justify-center rounded-xxl h-auto w-auto border-1',
                        disableBackground,
                        isAlreadySelected(addition) ? 'p-1.5' : 'p-1'
                      ]"
                      :style="
                 isAlreadySelected(addition)
                          ? listActivePrice + listActivePriceBorder
                          : '' + additionAddBackground
                      "
                    >
                      <svg 
                        v-if="isAlreadySelected(addition)"
                        xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" 
                        :stroke="
                          isAlreadySelected(addition)
                          ? selectItemActiveColor
                          : selectItemColor
                        "
                        stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                      <svg
                        v-else
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="w-4 h-4"
                      >
                        <path
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                          fill="none"
                          :stroke="
                          isAlreadySelected(addition)
                          ? selectItemActiveColor
                          : selectItemColor
                        "
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lang from "../lang";
import _ from "lodash";
// import comboAddition from "./ComboAddition.vue";
export default {
  props: {
    modifier: {
      type: Object,
      required: true,
    },
    modifierGroup: {
      type: Object,
      default: () => {},
    },
    groupIndex: Number,
    allSelectedModifiers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      lodash: _,
      lang: lang,
      selectedModifiers: [],
      selectedComboModifiers: {},
      comboDealIndex: 0,
      comboGroupDealIndex: 0,
      // used for saving additions and using them for editing an cart item
      selectedAdditions: [],

      // Temporary to keep the Ids to match with the theme.
      selectedModifiersArray: [],
      disableModifiers: false,
      modifiersMessage: "",
      disableBackground: "",
      isActive: false,
      CurrentTheme: localStorage.getItem("theme"),
      previeusAdditionPrice: 0,
      previeusAdditionId: 0,
      radioButtonLength: false,
    };
  },
  computed: {
      ...mapGetters([
      "menu",
      "itemPrice",
      "language",
      "currency",
      "theme",
      "minSelectedAddition",
      "minSelectedAdditionTotal",
      "menuHash",
      "minSelectedAdditionComboTotal",
      "minModifiersCheck",
    ]),
    ...mapGetters("Cart", ["comboDealAdditions"]),
    ...mapGetters("Theme", [
      "itemAdditionsRadius",
      "listsText",
      "listsBackground",
      "listsActiveText",
      "listsActiveBackground",
      "listActivePrice",
      "listActivePriceText",
      "selectItemColor",
      "kioskItemBorder",
      "kioskModifierItemBorder",
      "kioskAdditionTitleLine",
      "listActivePriceBorder",
      "additionAddBackground",
      "kioskAdditionTitleColor",
      "selectItemActiveColor",
      "mainSubCategorysBackground",
      "menuSubCategoriesBackground",
    ]),
  },
  methods: {
    isAlreadySelected(modifier){
      return this.allSelectedModifiers.some(el=>{
        return el.Id==modifier.Id&&el.combo_deal_item_id==modifier.combo_deal_item_id;
      })
    },
    // childValue
    uncheck(event, id, price) {
      if (id != this.previeusAdditionId) {
        this.previeusAdditionId = id;
        this.previeusAdditionPrice = price;
      } else {
        this.previeusAdditionId = 0;
        this.previeusAdditionPrice = 0;
      }
    },
    selectModifier(modifierGroupId, price, id, data) {
      this.handleComboChange(data.addition)
      this.selectedComboModifiers = data.addition;
      if (data.addition.combo_deal_item_id) {
        if (this.modifier.minSelectedAmount > 1) {
          if (this.lengthModifiersDiff <= this.modifier.minSelectedAmount) {
            //updates the mincount in the array so we know how many additions we clicked
            if (this.isAlreadySelected(data.modifierGroup))
             {
              this.minModifiersCheck.map((y) => {
                if (y.id == modifierGroupId) {
                  y.minCount -= 1;
                }
              });
            }
          }
        }
        setTimeout(() => {
          window.$eventBus.$emit("additions-selected", {
            modifierGroupId: data.modifierGroup.AdditionGroupId,
            comboDealId: this.modifierGroup.combo_deal_item_id,
            selectedModifiers: this.selectedComboModifiers,
          });
        }, 100);
      } else {
        setTimeout(() => {
          window.$eventBus.$emit("additions-selected", {
            modifierGroupId: modifierGroupId,
            comboDealId: this.modifierGroup.combo_deal_item_id,
            selectedModifiers: this.selectedModifiers,
          });
        }, 100);
      }
    },
    giveComboDealId(index, groupIndex) {
      this.comboDealIndex = index;
      this.comboGroupDealIndex = groupIndex;
    },
    handleComboChange(currentValue) {
      let allmodifiers = this.modifier.Additions.map((x) => x.Id);
      if (
        this.comboDealAdditions.data[this.comboGroupDealIndex]
        // &&
        // this.comboDealAdditions.data[this.comboGroupDealIndex]
          // .maxSelectedAmount == 1
      ) {
        // Get the current addition group on click
        const additions =
          document.querySelectorAll(`.allComboAdditions`)[this.groupIndex];
        // get all the additions with the additionPicture class in it
        const specificAdditions = additions.querySelectorAll(
          ".AdditionItemWrapper"
        );
        if (
          document.querySelectorAll(`.allComboAdditions`)[
            // eslint-disable-next-line no-use-before-define
            this.groupIndex
          ].classList.contains("AdditionSelected")
        ) {
          document.querySelectorAll(`.allComboAdditions`)[
            // eslint-disable-next-line no-use-before-define
            this.groupIndex
          ].classList.add("AdditionSelected");
          if (this.comboDealAdditions.data[this.comboGroupDealIndex].maxSelectedAmount == 1) {
            if (this.isAlreadySelected(currentValue)) {  
              specificAdditions.forEach((s) => {
                s.classList.add("AdditionItemWrapper--open");
                s.classList.remove("AdditionItemWrapper--closed");
              document.querySelectorAll(`.allComboAdditions`)[
              // eslint-disable-next-line no-use-before-define
              this.groupIndex
            ].classList.remove("AdditionSelected");
            });
            }
            else {
              specificAdditions.forEach((s) => {
              s.classList.add("AdditionItemWrapper--closed");
              s.classList.remove("AdditionItemWrapper--open");
            });
            }
          }
          else {
            let duplicateArray = [...this.allSelectedModifiers];
            if (this.isAlreadySelected(currentValue)) {
              duplicateArray = duplicateArray.filter(obj => obj.Id !== currentValue.Id);
              specificAdditions.forEach((s) => {
                 s.classList.add("AdditionItemWrapper--open");
                s.classList.remove("AdditionItemWrapper--closed");
              });
            }
            else {
              let count = 0;
              duplicateArray.forEach((el) => {
                if (el.AdditionGroupId == currentValue.AdditionGroupId) {
                  count++
                }
              })
              if (count < this.comboDealAdditions.data[this.comboGroupDealIndex].maxSelectedAmount) {
                duplicateArray.push(currentValue) 
                if (count == (this.comboDealAdditions.data[this.comboGroupDealIndex].maxSelectedAmount - 1)) {
                  document.querySelectorAll(`.allComboAdditions`)[
                  this.groupIndex
                  ].classList.add("AdditionSelected");
                  specificAdditions.forEach((s) => {
                  s.classList.add("AdditionItemWrapper--closed");
                  s.classList.remove("AdditionItemWrapper--open");
                });
                }
              }
            }
          }
        } else{
          document.querySelectorAll(`.allComboAdditions`)[
            // eslint-disable-next-line no-use-before-define
            this.groupIndex
          ].classList.add("AdditionSelected");
          if(this.comboDealAdditions.data[this.comboGroupDealIndex].maxSelectedAmount == 1)
            specificAdditions.forEach((s) => {
          s.classList.add("AdditionItemWrapper--closed");
          s.classList.remove("AdditionItemWrapper--open");
        });
        }

        document.querySelectorAll(`.allComboAdditions`)[
          // eslint-disable-next-line no-use-before-define
          this.groupIndex
        ].classList.remove("required");


        // this returns all the current ID's from the additiongroup you click in
        // let allmodifiers = this.modifier.Additions.map((x) => x.Id);
        if (this.minModifiersCheck.length) {
          // if the id's are not the same we know that its the first time we click on that addition group so we put that in the array so we can hold that data
          this.minModifiersCheck.map((x) => {
            if (x.id == this.modifier.AdditionGroupId) {
              x.minCount = 0;
            } else {
              if (this.modifier.minSelectedAmount != 0) {
                this.$store.commit("updateMinModifiersCheck", {
                  id: this.modifier.AdditionGroupId,
                  min: this.modifier.minSelectedAmount,
                  minCount: 0,
                  continue: false,
                });
                // we only want to store the same items 1 time in the array so we sort them out and store them
                this.$store.commit(
                  "transformMinModifiersCheck",
                  _.uniqBy(this.minModifiersCheck, "id")
                );
              }
            }
          });
        } else {
          if (this.modifier.minSelectedAmount != 0) {
            this.$store.commit("updateMinModifiersCheck", {
              id: this.modifier.AdditionGroupId,
              min: this.modifier.minSelectedAmount,
              minCount: 0,
              continue: false,
            });
          }
        }

        let objectId = { Id: this.selectedComboModifiers.Id };
        if (objectId?.Id)
          this.selectedModifiersArray = _.map(objectId, (item) => item);
        // return (this.selectedModifiersArray += this.selectedModifiers.Id);
      } else {
        this.selectedModifiersArray = _.map(
          this.selectedComboModifiers,
          function (item) {
            return item.Id;
          }
          );
        }

      /** Disable add to cart button disabled when minimum one modifers is allowed. */

      // if min 1 item needs to be selected
      if (
        this.comboDealAdditions.data[this.comboGroupDealIndex]
          .minSelectedAmount == 1
      ) {
        if (
          this.comboDealAdditions.data[this.comboGroupDealIndex]
            .maxSelectedAmount == 1
        ) {
          let radioBtnCurrentValue = [currentValue];
          if (
            radioBtnCurrentValue.length >=
            this.comboDealAdditions.data[this.comboGroupDealIndex]
              .minSelectedAmount
          ) {
            if (radioBtnCurrentValue[0].Id && !this.radioButtonLength) {
              //refactor this function in later stadium / this keeps the right number of selected MIN additions
            } else {
              this.radioButtonLength = false;
              if (
                this.isAlreadySelected(
                  currentValue
                ) ||
                !radioBtnCurrentValue[0].Id
              ) {
                this.$store.commit(
                  "updateMinSelectedAdditionComboTotal",
                  this.minSelectedAdditionComboTotal - 1
                );
              }

            }
            if (radioBtnCurrentValue[0].Id) {
              document.querySelectorAll(`.allComboAdditions`)[
                // eslint-disable-next-line no-use-before-define
                this.groupIndex
              ].classList.add("AdditionSelected");
              this.radioButtonLength = true;
              this.$store.commit(
                "updateMinSelectedAdditionComboTotal",
                this.minSelectedAdditionComboTotal + 1
              );
            }
            this.modifiersMessage = "";
          } else {
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];
          }
          if (currentValue.length == 0) {
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];          }
        } else {
          //updates the mincount in the array so we know how many additions we clicked
          if (Array.isArray(currentValue)) {
            currentValue.map((x) =>
            this.minModifiersCheck.map((y) => {
              if (y.id == x.AdditionGroupId) {
                y.minCount += 1;
              }
            })
          );
          }
          else {
              this.minModifiersCheck.map((y) => {
                if (y.id == currentValue.AdditionGroupId) {
                  y.minCount += 1;
                }
              })
          }
          if (currentValue.length && !this.radioButtonLength) {
            //refactor this function in later stadium / this keeps the right number of selected MIN additions
          } else {
            this.radioButtonLength = false;
          }
          if (currentValue.length) {
            this.radioButtonLength = true;
          }
          if (
            currentValue.length >=
            this.comboDealAdditions.data[this.comboGroupDealIndex]
              .minSelectedAmount
          ) {
            this.modifiersMessage = "";
          } else {
            // if not enough items are selected then block button
            this.modifiersMessage =
              this.lang["minimum_one_item_is_required"][this.language];
          }
        }
      }
      if (this.modifier.minSelectedAmount > 1) {
        if (
          this.minSelected == this.modifier.minSelectedAmount ||
          !this.minselectedbool
        ) {
          //     //refactor this function in later stadium / this keeps the right number of selected MIN additions
        }
        if (currentValue.length) {
          this.radioButtonLength = true;
          this.minSelected += 1;
        }
        let currentModifiers = this.selectedModifiersArray;
        let lengthModifiers = _.difference(
          allmodifiers,
          currentModifiers
        ).length;
        this.lengthModifiersDiff = allmodifiers.length - lengthModifiers;
        //updates the mincount in the array so we know how many additions we clicked
        if (Array.isArray(currentValue)) {
          currentValue.map((x) =>
            this.minModifiersCheck.map((y) => {
              if (y.id == x.AdditionGroupId) {
                y.minCount += 1;
              }
            })
            );
        }
        else {
          this.minModifiersCheck.map((y) => {
            if (y.id == currentValue.AdditionGroupId) {
              y.minCount += 1;
            }
          })
        }
      }


      /** In Case when Unlimited Modifieres are allowed */
      if (
        this.comboDealAdditions.data[this.comboGroupDealIndex]
          .maxSelectedAmount == -1
      ) {
        this.$store.commit("updateModifierNumber", 0);
        this.modifiersMessage =
          this.lang["multiple_modifiers_can_be_selected"][this.language];
        return (this.disableModifiers = false), (this.disableBackground = "");
      }

      if (
        this.comboDealAdditions.data[this.comboGroupDealIndex]
          .maxSelectedAmount == 1
      ) {
        this.$store.commit("updateModifierNumber", 1);
        /** When one modifier is selected then disable the further selection. */
        if (currentValue.length == 1) {
          this.modifiersMessage =
            this.lang["only_one_modifier_allowed"][this.language];
          this.disableBackground = "opacity-30";
          return (this.disableModifiers = true);
        } else {
          return (this.disableModifiers = false), (this.disableBackground = "");
        }
      }
      this.$store.commit("updateModifierNumber", 0);
      return (this.disableModifiers = false), (this.disableBackground = "");
    },
    handleChangeEmit() {
      this.$emit("change", {
        additionGroup: this.modifier,
        additions: Array.isArray(this.selectedComboModifiers)
          ? this.selectedComboModifiers.map((d) => ({ Addition: d }))
          : { Addition: this.selectedComboModifiers },
      });
    },
  },
  watch: {
    selectedComboModifiers(currentValue) {
      this.handleChangeEmit();
      this.handleComboChange(currentValue);
    },
  },
};
</script>

<style>
.required .requiredTitle {
  color: red;
  font-weight: bold;
}

.required.animated .requiredTitle {
  animation: 1.5s ease-out 0s 1 slideInFromLeft;
}

</style>
